<template>
  <Modal
    v-model="_value"
    width="700"
    title="查看/修改维修订单"
    @on-visible-change="visibleChange"
    cancel-text=""
    ok-text="关闭">
    <div style="position:relative;">
      <Form :model="maintainOrder" :label-width="90">
        <FormItem prop="vehicleInfoId" label="问题车辆">
          <Select :disabled="true"
                  ref="selectQuestionVehicleInfoRef"
                  placeholder="请选择问题车辆"
                  v-model="maintainOrder.vehicleInfoId"
                  filterable
                  remote
                  :remote-method="searchVehicleInfo"
                  :loading="searchVehicleInfoLoading"
                  class="field"
                  clearable>
            <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="option.id">{{option.registrationNum==null?option.vin:option.registrationNum}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="bookingDatetime" label="预约时间">
          <DatePicker :disabled="!modify" type="date" v-model="maintainOrder.bookingDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem prop="question" label="订单类型">
          <Select :disabled="!modify" v-model="maintainOrder.maintainType" style="width: 220px;">
            <Option v-for="item in maintainTypeOptions" :value="item.value" :key="item.value">
              {{item.name}}
            </Option>
          </Select>
        </FormItem>
        <FormItem prop="question" label="问题描述">
          <Input :disabled="!modify" class="field" v-model="maintainOrder.question"
                 type="textarea">
          </Input>
        </FormItem>
        <FormItem prop="remark" label="备注">
          <Input :disabled="true" class="field" v-model="maintainOrder.remark" type="textarea">
          </Input>
        </FormItem>
        <FormItem prop="history" label="历史记录">
          <Input :disabled="true" class="field" v-model="maintainOrder.history" type="textarea">
          </Input>
        </FormItem>
        <FormItem prop="modify" style="text-align: right;">
          <i-switch v-model="modify" @on-change="modifyChange" size="large">
            <span slot="open">保存</span>
            <span slot="close">修改</span>
          </i-switch>
        </FormItem>
        <FormItem prop="maintainDeviceRecords" label="维修设备记录">
          <Table border highlight-row size="small" height="200" :columns="maintainDeviceRecordColumns" :stripe="true" :data="maintainOrder.maintainDeviceRecords==null?[]:maintainOrder.maintainDeviceRecords" ref="table"></Table>
        </FormItem>
        <FormItem prop="modify" style="text-align: right;">
          <Button size="small" type="primary" @click="onAddMaintainDeviceRecord">增加设备维修记录</Button>
        </FormItem>
      </Form>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <maintain-order-add-maintain-device-record-modal v-model="maintainOrderAddMaintainDeviceRecordModal" :initValue="maintainOrderAddMaintainDeviceRecordId" @on-success="onSuccess"></maintain-order-add-maintain-device-record-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'maintainorderdetailmodal',
  components: {
    MaintainOrderAddMaintainDeviceRecordModal
  },
  props: {
    initValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataLoading: false,
      modify: false,

      // 增加设备维修记录
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: null,

      searchVehicleInfoLoading: false,
      searchVehicleInfoList: [],

      maintainOrder: {
        id: null,
        vehicleInfoId: null,
        bookingDatetime: null,
        maintainType: null,
        question: null,
        remark: null,
        maintainDeviceRecords: []
      },

      //维修订单类型
      maintainTypeOptions: [
        {name: '维修', value: 0},
        {name: '返修', value: 1},
      ],

      maintainDeviceRecord: {
        terminalNum: null,
        newTerminalNum: null,
        newFactoryTerminalNum: null,
        newPositioningDeviceModel: null,
        newPositioningDeviceModelId: null,
        changeDevice: false,
        changeSim: false,
        removeDevice: false,
        positioningDeviceInfoId: null,
        positioningDeviceInfo: null,
        result: null,
        maintainOrderId: null
      },

      maintainDeviceRecordColumns: [
        {
          title: 'id',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          width: 80
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          sortable: 'custom',
          width: 130
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          width: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceInfo.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceInfo.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            }else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceInfo.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '记录类型',
          resizable: true,
          key: 'positioningDeviceModel',
          sortable: 'custom',
          width: 160,
          render: function (h, params) {
            let div = ''
            if (params.row.changeDevice) {
              div += '换机;' + params.row.newFactoryTerminalNum
            }
            if (params.row.changeSim) {
              div += '换卡;' + params.row.newTerminalNum
            }
            if (params.row.removeDevice) {
              div += '拆机;'
            }
            console.log(div)
            return h('div', div)
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 160,
          fixed: 'right',
          render: (h, params) => {
            let display = [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '提示',
                      content: '<p>确认删除</p>',
                      onOk: () => {
                        store.dispatch('MaintainOrderServ_RemoveMaintainDeviceRecord', {
                          params: { maintainDeviceRecordId: params.row.id }
                        }).then(() => {
                          this.$Message.success('删除完成')
                          this.refresh()
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '删除'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.maintainDeviceRecord = params.row
                    this.$Modal.confirm({

                      render: (h) => {
                        return h('Input', {
                          props: {
                            value: null,
                            // autofocus: true,
                            placeholder: '维修结果'
                          },
                          on: {
                            input: (val) => {
                              this.maintainDeviceRecord.result = val
                            }
                          }
                        })
                      },

                      title: '添加维修结果',
                      content: '<p>确认添加</p>',
                      onOk: () => {
                        console.log(this.maintainDeviceRecord)
                        store.dispatch('MaintainOrderServ_ModifyMaintainDeviceRecord', {
                          params: this.maintainDeviceRecord
                        }).then(() => {
                          this.$Message.success('添加完成')
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '添加维修结果')
            ]

            return h('div', display)
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    searchVehicleInfo (input) {
      this.searchVehicleInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoList = []
        this.searchVehicleInfoLoading = false
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoList = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
          this.searchVehicleInfoLoading = false
        }).catch(err => {
          this.searchVehicleInfoLoading = false
        })
      }
    },
    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认修改维修订单</p>',
          onOk: () => {
            this.maintainOrder.vehicleInfo = null
            store.dispatch('MaintainOrderServ_ModifyObj', { params: this.maintainOrder }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
              this.refresh()
            })
          },
          onCancel: () => {
            this.refresh()
          }
        })
      }
    },
    onSuccess () {
      this.refresh()
    },
    refresh () {
      store.dispatch('MaintainOrderServ_GetDetail', {
        params: { id: this._initValue }
      }).then(() => {
        this.maintainOrder = store.getters.get_MaintainOrder_GetDetailResult
        this.maintainOrder.bookingDatetime = new Date(this.maintainOrder.bookingDatetime)

        let vehicleInfo = this.maintainOrder.vehicleInfo
        if (vehicleInfo) {
          let vehicleName = vehicleInfo.registrationNum == null ? vehicleInfo.vin : vehicleInfo.registrationNum
          Vue.set(vehicleInfo, 'key', vehicleInfo.id)
          Vue.set(vehicleInfo, 'label', vehicleName)
          this.maintainOrder.vehicleInfoId = null
          this.searchVehicleInfoList = []
          this.searchVehicleInfoList.push(vehicleInfo)
          this.maintainOrder.vehicleInfoId = store.getters.get_MaintainOrder_GetDetailResult.vehicleInfoId
          this.$refs['selectQuestionVehicleInfoRef'].query = vehicleName
          // this.initDisplayVehicleName = vehicleName
        }
        this.dataLoading = false
      }).catch(err => {
        this.$Message.error(err)
        this.dataLoading = false
      })
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.maintainOrder.vehicleInfoId = null
        this.maintainOrder.bookingDatetime = null
        this.maintainOrder.maintainType = null
        this.maintainOrder.question = null
        this.maintainOrder.remark = null
        this.refresh()
      }
    },
    onAddMaintainDeviceRecord () {
      this.maintainOrderAddMaintainDeviceRecordModal = true
      this.maintainOrderAddMaintainDeviceRecordId = this._initValue
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
